import React, {Component} from 'react';
import Const from 'constants';
import {sortByProperty} from 'helpers/sorters';
import TeamExposure from 'components/organisms/nhl-team-stacking/components/team-exposure';
import {calcPercentage} from 'helpers/common-helper';
import NhlTeamStackingMarker from 'components/organisms/nhl-team-stacking/services/nhl-team-stacking-marker';
import NhlLegacyTeamStackingMarker from 'components/organisms/nhl-legacy-team-stacking/services/nhl-legacy-team-stacking-marker';

class BaseStackSummary extends Component {
    prepareTeams() {
        const {rawLineups} = this.props;

        const teams = {};
        rawLineups.asArr().map((rawLineup) => {
            let markedItems = NhlTeamStackingMarker.pickMarkedBySuffix(rawLineup.getOriginalLineup());

            if (isEmpty(markedItems)) {
                markedItems = NhlLegacyTeamStackingMarker.pickMarkedBySuffix(rawLineup.getOriginalLineup());
            }

            markedItems.map((markedItem) => {
                if (markedItem[0] !== Const.LP_SUBGROUP_PREFIX) {
                    return;
                }

                const [teamName] = markedItem.replace(Const.LP_SUBGROUP_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

                teams[teamName] ??= {teamName, quantity: 0};
                teams[teamName].quantity++;
            });
        });

        return Object.values(teams).sort(sortByProperty('quantity', 'desc'));
    }

    getNotFoundView() {
        return (
            <table key={-1} className="table">
                <tbody>
                    <tr key="teams-not-found" className="empty">
                        <td>Teams were not found.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    getTeamStackView(teamNumber, team) {
        const {rawLineups} = this.props;
        const percentage = calcPercentage(rawLineups.getQuantity(), team.quantity);
        const className = teamNumber % 2 === 0 ? 'even' : '';

        return (
            <tr key={team.teamName} className={className}>
                <td>
                    <strong>{team.teamName}</strong>
                </td>
                <td className="text-blue">
                    {percentage}% ({team.quantity})
                </td>
                <td>
                    <div className="percent-in">
                        <TeamExposure
                            team={team.teamName}
                            exposureType="max"
                            stackNumber={1}
                            className="form-control small-table-input"
                        />
                        <span className="percent">%</span>
                    </div>
                </td>
            </tr>
        );
    }

    getTeamsStackView(teams) {
        if (isEmpty(teams)) {
            return this.getNotFoundView();
        }

        const rows = teams.map((team, i) => this.getTeamStackView(i, team));

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>{`${teams.length} Teams Used in Stack`}</th>
                        <th></th>
                        <th>
                            Exp.
                            <br />
                            max
                        </th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

export {BaseStackSummary};
